import ContentManage from './contentManage'
import ContentDetail from './detail'
import ContentView from './view'
import ContentPreview from './preview'
import ContentLabel from './label'
import ContentRecord from './record'
import TaskInfo from './task/taskInfo'
import TaskEdit from './task/taskEdit'
import TaskRecord from './task/taskRecord'
import TaskNotice from './task/taskNotice'
import VerbalTrickManager from './verbalTrick/index'
import VerbalTrickDetail from './verbalTrick/detail/verbalTrickDetail'
import KnowledgeBaseList from './proKnowledge/knowledgeBase/knowledgeBaseList'
import KnowledgeBaseDetail from './proKnowledge/knowledgeBase/knowledgeBaseDetail/knowledgeBaseDetail'
import KnowledgeBaseLook from './proKnowledge/knowledgeBase/knowledgeBaseDetail/knowledgeBaseLook'
import KnowledgeTypeList from "./proKnowledge/knowledgeType/knowledgeTypeList";
import KnowledgeTypeDetail from "./proKnowledge/knowledgeType/knowledgeTypeDetail/knowledgeTypeDetail";
import KnowledgeRecordList from './proKnowledge/knowledgeBase/knowledgeRecod/knowledgeRecordList'

export {
  ContentManage,
  ContentDetail,
  ContentView,
  ContentPreview,
  ContentLabel,
  ContentRecord,
  TaskInfo,
  TaskEdit,
  TaskRecord,
  TaskNotice,
  VerbalTrickManager,
  VerbalTrickDetail,
  KnowledgeBaseList,
  KnowledgeBaseDetail,
  KnowledgeBaseLook,
  KnowledgeTypeList,
  KnowledgeTypeDetail,
  KnowledgeRecordList
}
